export default {"src":"/org/_next/static/media/log-out.6152f797.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};